import { StyleSheet, Platform } from 'react-native';
import Colors from '../../../constants/Colors';

export const styles = StyleSheet.create({
  item: {
    width: '100%',
    maxWidth: Platform.OS === 'web' ? 768 : '100%',
    flexGrow: 1,
  },
  paragraph: {
    marginBottom: 10,
  },
  img: {
    aspectRatio: 1000 / 720,
  },
  button: {
    marginTop: 10,
  },
  description: {
    height: 140,
    textAlignVertical: 'top',
    borderRadius: 10,
    padding: 8,
    marginBottom: 10,
  },
  oldDescription: {
    borderWidth: 1,
    borderColor: Colors.lightBlue2,
  },
  newDescription: {
    backgroundColor: Colors.lightBlue2,
    marginBottom: 30,
    borderWidth: 1,
    borderColor: Colors.lightBlue2,
  },
  descriptionInput: {
    height: 140,
    textAlignVertical: 'top',
  },
  buttonLeft: {
    flex: 1,
  },
  buttonMiddle: {
    marginHorizontal: 10,
    flex: 1,
  },
  buttonRight: {
    flex: 1,
  },
  action: {
    padding: 10,
    borderRadius: 10,
  },
  actionAccepted: {
    backgroundColor: Colors.green,
  },
  actionRejected: {
    backgroundColor: Colors.red,
  },
  oldLocation: {
    height: 48,
    textAlignVertical: 'top',
    // backgroundColor: Colors.blue,
    borderWidth: 1,
    borderColor: Colors.lightBlue,
    borderRadius: 10,
    padding: 8,
    marginBottom: 10,
    justifyContent: 'center',
  },
  newLocation: {
    height: 48,
    textAlignVertical: 'top',
    backgroundColor: Colors.lightBlue2,
    // borderWidth: 1,
    // borderColor: Colors.lightBlue,
    borderRadius: 10,
    padding: 8,
    marginBottom: 10,
    justifyContent: 'center',
  },
  img: {
    width: '100%',
  },
  imgCaption: {
    width: '100%',
    marginBottom: 10,
  },
  oldCaption: {
    height: 48,
    backgroundColor: Colors.lightBlue2,
    borderRadius: 10,
    padding: 8,
    marginBottom: 10,
    justifyContent: 'center',
  },
  caption: {
    marginBottom: 20,
    // borderWidth: 1,
    // borderTopWidth: 0,
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
    borderColor: Colors.lightBlue2,
    padding: 10,
    borderRadius: 10,
    backgroundColor: Colors.textInputBackground,
  },
  milestone: {
    // backgroundColor: Colors.textInputBackground,
    // backgroundColor: Colors.blue2,
    borderRadius: 10,
    padding: 10,
    marginBottom: 10,
    borderColor: Colors.lightBlue2,
    borderWidth: 1,
  },
  newMilestone: {
    backgroundColor: Colors.textInputBackground,
    backgroundColor: Colors.lightBlue2,
  },
  disabled: {
    // backgroundColor: Colors.lightGrey,
    color: Colors.lightGrey,
  },
  pdfContainer: {
    flex: 1,
    flexGrow: 1,
    // minHeight: 200,
    // maxHeight: 400,
    // height: 300,
  }
});

export default styles;